export default __webpack_public_path__ + "static/media/psd.2e9987cb.svg";